import { TOOLTIP_Z_INDEX } from 'consts/zIndex'

import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import styled from 'styled-components'
import { motion } from 'framer-motion'

interface ITooltipWrapperStyle {
  $position: { x: number; y: number }
  $maxWidth: number | undefined
  $textAlign?: 'left' | 'right' | 'center'
}

interface ITooltipArrowStyle {
  $borderWidth: number
}

export const TooltipWrapper = styled(motion.div)<ITooltipWrapperStyle>`
  position: absolute;
  top: ${props => `${props.$position.y}px`};
  left: ${props => `${props.$position.x}px`};
  z-index: ${TOOLTIP_Z_INDEX};
  max-width: ${props => (props.$maxWidth ? `${props.$maxWidth}px` : '240px')};
  padding: 8px;
  background: ${COLORS.textPrimary};
  border-radius: ${RADII.item};
  color: ${COLORS.white};
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: ${props => props.$textAlign};
`
export const TooltipArrow = styled.div<ITooltipArrowStyle>`
  width: ${props => `${props.$borderWidth}px`};
  height: ${props => `${props.$borderWidth}px`};
  position: absolute;
  background: ${COLORS.textPrimary};
`
